/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "uint32",
                name: "index",
                type: "uint32",
            },
        ],
        name: "getGuardianSet",
        outputs: [
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "keys",
                        type: "address[]",
                    },
                    {
                        internalType: "uint32",
                        name: "expirationTime",
                        type: "uint32",
                    },
                ],
                internalType: "struct Structs.GuardianSet",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCurrentGuardianSetIndex",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getGuardianSetExpiry",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "messageFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "emitter",
                type: "address",
            },
            {
                internalType: "uint16",
                name: "targetChainId",
                type: "uint16",
            },
        ],
        name: "nextSequence",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
export class Getters__factory extends ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
Getters__factory.bytecode = _bytecode;
Getters__factory.abi = _abi;
